import { FieldTypes } from '../../constants/FieldTypes'
import { DropdownField, Field, FieldMap, ListField, TextField } from '../../types/forms/fields'

const nameField: Field = {
  type: FieldTypes.TEXT,
  placeholder: 'Name',
}
const indicationField: Field = {
  type: FieldTypes.TEXTAREA,
  optional: true,
  placeholder: 'Indication (why you are taking this medication, if not listed above)',
}

const dosageField: Field = {
  type: FieldTypes.TEXT,
  placeholder: 'Dosage',
  row: {
    index: 0,
    flex: 1,
  },
}

const frequencyField: Field = {
  type: FieldTypes.TEXT,
  placeholder: 'Frequency',
  row: {
    index: 0,
    flex: 1,
  },
}

const startDateField: Field = {
  type: FieldTypes.DATE,
  placeholder: 'Start date',
  row: {
    index: 1,
    flex: 1,
  },
}

const currentlyTakingField: Field = {
  type: FieldTypes.BOOLEAN,
  placeholder: 'Currently taking',
  row: {
    index: 1,
    flex: 1,
  },
}

const stopDateField: Field = {
  type: FieldTypes.DATE,
  placeholder: 'Stop date',
  condition: v => v?.currentlyTaking === false,
  row: {
    index: 1,
    flex: 1,
  },
}

export const administeredViaField: Field = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Administered via',
  options: [
    {
      text: 'Oral',
      id: 'oral',
    },
    {
      text: 'Sublingual',
      id: 'sublingual',
    },
    {
      text: 'IM (intramuscular)',
      id: 'im',
    },
    {
      text: 'IV (intravenous)',
      id: 'iv',
    },
    {
      text: 'Topical',
      id: 'topical',
    },
    {
      text: 'Rectal',
      id: 'rectal',
    },
    {
      text: 'Vaginal',
      id: 'vaginal',
    },
    {
      text: 'Subcutaneous',
      id: 'subcutaneous',
    },
    {
      text: 'Inhalation',
      id: 'inhalation',
    },
    {
      text: 'Ophthalmic (eye)',
      id: 'ophthalmic',
    },
    {
      text: 'Intrauterine',
      id: 'intrauterine',
    },
    {
      text: 'Buccal (between the cheek and gum)',
      id: 'buccal',
    },
  ],
}

// const instructionsField: Field = {
//   type: FieldTypes.TEXTAREA,
//   placeholder: 'Instructions',
//   optional: true,
// }

export const getMedicationField = (withIndication?: boolean): FieldMap => {
  const children: Record<string, Field> = {
    name: nameField,
  }
  children.dosage = dosageField
  children.frequency = frequencyField
  children.administeredVia = administeredViaField
  children.startDate = startDateField
  children.currentlyTaking = currentlyTakingField
  children.stopDate = stopDateField
  if (withIndication) {
    children.indication = indicationField
  }
  // children.instructions = instructionsField
  return {
    name: 'Medication',
    children,
  }
}
//options: Capsule, softgel capsule, tablet, liquid, topical cream, device, drops, foam, gel, gummy, inhaler, injection, lotion, ointment, patch, powder, spray, suppository, other
const supplementFormField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Supplement form',
  searchable: true,
  row: {
    index: 2,
    flex: 1,
  },
  options: [
    { text: 'Capsule', id: 'capsule' },
    { text: 'Softgel capsule', id: 'softgel_capsule' },
    { text: 'Tablet', id: 'tablet' },
    { text: 'Liquid', id: 'liquid' },
    { text: 'Topical cream', id: 'topical_cream' },
    { text: 'Device', id: 'device' },
    { text: 'Drops', id: 'drops' },
    { text: 'Foam', id: 'foam' },
    { text: 'Gel', id: 'gel' },
    { text: 'Gummy', id: 'gummy' },
    { text: 'Inhaler', id: 'inhaler' },
    { text: 'Injection', id: 'injection' },
    { text: 'Lotion', id: 'lotion' },
    { text: 'Ointment', id: 'ointment' },
    { text: 'Patch', id: 'patch' },
    { text: 'Powder', id: 'powder' },
    { text: 'Spray', id: 'spray' },
    { text: 'Suppository', id: 'suppository' },
    { text: 'Other', id: 'other' },
  ],
}

const supplementFormOtherField: TextField = {
  type: FieldTypes.TEXT,
  row: {
    index: 2,
    flex: 1,
  },
  placeholder: 'Other supplement form',
  condition: v => v?.supplementForm === 'other',
}

export const getSupplementField = (withIndication?: boolean): FieldMap => {
  const children: Record<string, Field> = {
    name: nameField,
  }
  children.dosage = dosageField
  children.frequency = frequencyField
  children.startDate = startDateField
  children.currentlyTaking = currentlyTakingField
  children.stopDate = stopDateField
  children.supplementForm = supplementFormField
  children.supplementFormOther = supplementFormOtherField
  if (withIndication) {
    children.indication = indicationField
  }
  return {
    name: 'Supplement',
    children,
  }
}

export const supplementsField: ListField = {
  optional: true,
  name: 'Supplements',
  itemFields: getSupplementField(true),
  itemName: 'Supplement',
}

export const medicationsAndSupplementsField: FieldMap = {
  name: 'Meds and Supplements',
  children: {
    medications: {
      optional: true,
      name: 'Medications',
      itemFields: getMedicationField(true),
      itemName: 'Medication',
    },
    supplements: supplementsField,
  },
}
